import {Component, OnInit, ViewChild} from '@angular/core';
import {Documents} from "../../dto/Documents";
import {TemplateComponent} from "../template/template.component";
import {Table} from "primeng/table";
import {Category} from "../../dto/Category";
import {MenuItem, TreeNode} from "primeng/api";
import {PageDoc} from "../../dto/PageDoc";
import {Post} from "../../dto/Post";
import {PostItem} from "../../dto/PostItem";
import {EditorBO} from "../bo/EditorBO";
import {NgxSuneditorComponent} from "ngx-suneditor";
import {ItemStyle} from "../../dto/ItemStyle";
import {FileUpload} from "primeng/fileupload";
import {UploadFile} from "../../dto/UploadFile";


@Component({
  selector: 'app-admin-docs',
  templateUrl: './admin-docs.component.html',
  styleUrls: ['./admin-docs.component.css']
})
export class AdminDocsComponent extends TemplateComponent implements OnInit {
  displayNewDoc: boolean = false;
  displayNewCategory: boolean = false;
  displayNewPage: boolean = false;
  displayNewPost: boolean = false;

  newDoc: Documents = new Documents();
  selectedDoc: Documents = new Documents();
  listDocs: Array<Documents> = new Array<Documents>();

  contextItems: MenuItem[] = [];
  // doc: string = "";
  // page: string = "";
  itemEditMode: boolean = false;
  postEditMode: boolean = false;
  hashtagList: Array<string> = new Array<string>();

  codeItemValue: any[] = [];

  ngOnInit(): void {
    this.global.doc = this.activeRoute.snapshot.paramMap.get("doc") + "";
    this.getDocList(null);
    this.contextItems = [
      {label: $localize`:@@Edit:Edit`, icon: 'pi pi-pencil', command: (event) => this.openEditPanel()},
      {label: $localize`:@@New Page:New Page`, icon: 'ico icon-file', command: (event) => this.openNewPageDialog()},
      {
        id: '2',
        label: $localize`:@@Delete Group:Delete Group`,
        icon: 'pi pi-trash',
        command: (event) => this.deleteCategoryDialog()
      },
      {
        id: '3',
        label: $localize`:@@Move up:Move up`,
        icon: 'ico icon-chevron-up',
        command: (event) => this.sortPage(-1)
      },
      {
        id: '4',
        label: $localize`:@@Move down:Move down`,
        icon: 'ico icon-chevron-down',
        command: (event) => this.sortPage(1)
      }
    ];


  }

  //...................Document.....................

  selectDoc(doc: Documents) {
    this.selectedDoc = doc;
    this.global.page = "";
    this.treeMap = new Map<string, TreeNode>();
    this.categoryTree = [];
    this.selectedPage = new PageDoc();
    this.selectedCategory = new Category();
    this.getCategoryList(null);
    // this.route.navigate(["dashboard/" + this.selectedDoc.name.replace(" ", "_")]);
    let path = "dashboard/" + this.selectedDoc.name.replace(" ", "_");
    window.history.replaceState(null, "", path);
  }

  addDocDialog() {
    this.newDoc = new Documents();
    this.displayNewDoc = true;
  }

  addDoc() {
    this.global.progressBar = true;
    var observable = this.restBack.doGet("doc/admin/save_doc" +
      "?id=" + this.newDoc.id +
      "&name=" + this.newDoc.name +
      "&label=" + this.newDoc.label +
      "&publish=" + this.newDoc.publish
    );
    observable.then((result: any) => {
      var status = result["status"];
      if (status == 200) {
        this.newDoc = new Documents();
        this.getDocList(null);
        this.displayNewDoc = false;

      }
      if (status == 400) {
        this.messageService.clear();
        if (result["message"] == "ConflictDocName") {
          this.messageService.add({
            severity: 'error',
            summary: $localize`:@@Error:Error`,
            detail: $localize`:@@The name of the document is repeated.:The name of the document is repeated.`
          });
        }
      } else if (status == 401) {
        this.gotoLogin();
      }

    }, error => {
      this.messageService.clear();
      this.messageService.add({
        severity: 'error',
        summary: $localize`:@@Error:Error`,
        detail: $localize`:@@Server side error:Server side error`
      });
    }).finally(() => {
      this.global.progressBar = false
    });


  }

  openEditDocDialog(doc: Documents) {
    this.displayNewDoc = true;
    Object.assign(this.newDoc, doc);
    // this.newDoc = doc;
  }

  deleteDocDialog() {
    this.confirmationService.confirm({
      message: $localize`:@@Are you sure to delete?:Are you sure to delete?`,
      header: $localize`:@@Delete:Delete`,
      acceptLabel: $localize`:@@Yes:Yes`,
      rejectLabel: $localize`:@@No:No`,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.global.progressBar = true;
        var observable = this.restBack.doGet("doc/admin/delete_doc" +
          "?id=" + this.newDoc.id +
          "&check=false"
        );
        observable.then((result: any) => {
          var status = result["status"];
          if (status == 200) {
            this.messageService.clear();
            this.messageService.add({
              severity: 'info',
              summary: $localize`:@@Delete:Delete`,
              detail: $localize`:@@The document was deleted:The document was deleted`
            });

            this.newDoc = new Documents();
            this.getDocList(null);
            this.displayNewDoc = false;
          } else if (status == 401) {
            this.gotoLogin();
          }

        }, error => {
          this.messageService.clear();
          this.messageService.add({
            severity: 'error',
            summary: $localize`:@@Error:Error`,
            detail: $localize`:@@Server side error:Server side error`
          });
        }).finally(() => {
          this.global.progressBar = false
        });
      },
      reject: () => {

      }
    });

  }

  getDocList(table: Table | null) {
    this.global.progressBar = true;
    var observable = this.restBack.doGet("doc/admin/get_docs" +
      "?page=" + (table != null ? table.first / 10 : 0) +
      "&nrpp=" + (table != null ? table.rows : 10) +
      "&id=" + this.newDoc.id +
      "&name=" + this.newDoc.name
    );
    observable.then((result: any) => {
      var status = result["status"];
      if (status == 200) {
        this.listDocs = result["entity"];
        if (this.listDocs.length > 0) {
          this.selectedDoc = this.listDocs[0];
          for (let listDoc of this.listDocs) {
            if (listDoc.name.replace(" ", "_") == this.global.doc) {
              this.selectedDoc = listDoc;
            }
          }

          this.getCategoryList(null);
        }
      } else if (status == 401) {
        this.gotoLogin();
      }

    }, error => {
      this.messageService.clear();
      this.messageService.add({
        severity: 'error',
        summary: $localize`:@@Error:Error`,
        detail: $localize`:@@Server side error:Server side error`
      });
    }).finally(() => {
      this.global.progressBar = false
    });


  }


  //.............Category.................
  newCategory: Category = new Category();
  selectedCategory: Category = new Category();
  listCategory: Array<Category> = new Array<Category>();
  filteredCategory: Array<Category> = new Array<Category>();
  categoryTree: TreeNode[] = [];
  selectedTree: TreeNode = {};
  deleteKey: string = "0";
  listPage: Array<PageDoc> = new Array<PageDoc>();

  openNewCategory() {
    this.newCategory = new Category();
    this.displayNewCategory = true;
  }

  addCategory() {
    this.global.progressBar = true;
    var observable = this.restBack.doGet("doc/admin/save_category" +
      "?id=" + this.newCategory.id +
      "&name=" + this.newCategory.name +
      "&doc_id=" + this.selectedDoc.id +
      (this.newCategory.parent ? "&parent_id=" + this.newCategory.parent?.id : "")
    );
    observable.then((result: any) => {
      var status = result["status"];
      if (status == 200) {
        this.newCategory = new Category();
        this.getCategoryList(null);
        this.displayNewCategory = false;
      } else if (status == 401) {
        this.gotoLogin();
      }

    }, error => {
      this.messageService.clear();
      this.messageService.add({
        severity: 'error',
        summary: $localize`:@@Error:Error`,
        detail: $localize`:@@Server side error:Server side error`
      });
    }).finally(() => {
      this.global.progressBar = false
    });
  }

  deleteCategoryDialog() {
    if (this.selectedTree.type == "CATEGORY") {
      // @ts-ignore
      this.newCategory = this.listCategory.find(c => c.id == this.selectedTree.key)
      this.confirmationService.confirm({
        message: $localize`:@@Are you sure to delete?:Are you sure to delete?`,
        header: $localize`:@@Delete:Delete`,
        acceptLabel: $localize`:@@Yes:Yes`,
        rejectLabel: $localize`:@@No:No`,
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.global.progressBar = true;
          var observable = this.restBack.doGet("doc/admin/delete_category" +
            "?id=" + this.newCategory.id
          );
          observable.then((result: any) => {
            var status = result["status"];
            if (status == 200) {
              this.deleteKey = this.newCategory.id + "";
              this.newCategory = new Category();
              this.categoryTree = [];
              this.treeMap.delete(this.newCategory.id + "");
              this.getCategoryList(null);
              this.displayNewCategory = false;
              this.messageService.clear();
              this.messageService.add({
                severity: 'info',
                summary: $localize`:@@Delete:Delete`,
                detail: $localize`:@@The document was deleted:The document was deleted`
              });
            } else if (status == 400) {
              this.messageService.clear();
              this.messageService.add({
                severity: 'error',
                summary: $localize`:@@Delete:Delete`,
                detail: $localize`:@@This group has subgroups and cannot be deleted.:This group has subgroups and cannot be deleted.`
              });
            } else if (status == 401) {
              this.gotoLogin();
            }

          }, error => {
            this.messageService.clear();
            this.messageService.add({
              severity: 'error',
              summary: $localize`:@@Error:Error`,
              detail: $localize`:@@Server side error:Server side error`
            });
          }).finally(() => {
            this.global.progressBar = false
          });
        },
        reject: () => {

        }
      });

    }
  }

  filterCategory(event: any) {
    this.filteredCategory = new Array<Category>();

    for (let category of this.listCategory) {
      if (category.name.indexOf(event.query) > -1) {
        if (category.id == 0)
          category.name = $localize`:@@No group:No group`;
        this.filteredCategory.push(category);
      }
    }
  }

  treeMap: Map<string, TreeNode> = new Map<string, TreeNode>()

  getCategoryList(table: Table | null) {
    let loadPost: boolean = false;

    this.global.page = this.activeRoute.snapshot.paramMap.get("page") + "";
    this.global.progressBar = true;
    var observable = this.restBack.doGet("doc/admin/get_category" +
      "?page=" + (table != null ? table.first / 10 : 0) +
      "&nrpp=" + (table != null ? table.rows : 500) +
      "&id=" + this.newCategory.id +
      "&doc_id=" + this.selectedDoc.id +
      "&name=" + this.newCategory.name
    );
    observable.then((result: any) => {
      var status = result["status"];
      if (status == 200) {
        this.categoryTree = [];
        this.listCategory = result["entity"];

// .........................Category............................................
        let first: boolean = true;
        for (let cg of this.listCategory) {

          if (cg.id > 0) {
            var treeGroup: TreeNode = {"data": []};
            treeGroup.key = cg.id + "";
            treeGroup.label = cg.name;
            treeGroup.children = [];
            treeGroup.type = 'CATEGORY';
            // if (cg.id == 0) {
            // @ts-ignore
            if (this.treeMap.get(cg.id + ""))
              // @ts-ignore
              treeGroup.expanded = this.treeMap.get(cg.id + "").expanded;
            // } else {
            //   treeGroup.leaf = false;
            // }
            treeGroup.selectable = true;
            this.treeMap.set(cg.id + "", treeGroup);
            if (cg.parent == null || cg.parent.id < 1) {
              // @ts-ignore
              this.categoryTree.push(this.treeMap.get(cg.id + ""));
            }
          } else {
            // this.categoryTree = this.categoryTree.filter(t => t.type != "PAGE");
            // cg.pageDocs = cg.pageDocs.sort((a, b) => (a.priority < b.priority ? -1 : 1));
            for (let p of cg.pageDocs) {
              var treeGroup: TreeNode = {"data": []};
              treeGroup.key = "p_" + p.id;
              treeGroup.label = p.label;
              treeGroup.children = [];
              treeGroup.type = 'PAGE';
              treeGroup.leaf = true;
              treeGroup.selectable = true;
              treeGroup.styleClass = "tree-page-node";
              if (p.label.length > 48) {
                treeGroup.styleClass += " tscroll";
              }
              treeGroup.parent = this.treeMap.get(cg.id + "");
              // this.treeMap.set("p_" + p.id, treeGroup);
              if (cg.parent == null || cg.parent.id < 1) {
                // @ts-ignore
                this.categoryTree.push(treeGroup);


              }

              if (this.selectedPage == null || this.selectedPage.id < 1) {
                if (first && (this.global.page == null || this.global.page == "null" || this.global.page == "")) {
                  first = false;
                  this.global.page = p.name;
                  this.selectedPage = p;
                  loadPost = true;
                  // this.route.navigate(["dashboard/" + this.selectedDoc.name.replace(" ", "_") + "/" + p.name.replace(" ", "_")]);
                  let path = "dashboard/" + this.selectedDoc.name.replace(" ", "_") + "/" + p.name.replace(" ", "_");
                  window.history.replaceState(null, "", path);
                } else if (p.name.replace(" ", "_") == this.global.page) {
                  this.selectedPage = p;
                  this.selectedTree = treeGroup;
                  loadPost = true;

                }
              }
            }

          }
        }

        for (let cg of this.listCategory) {
          if (cg.id > 0) {
            if (cg.parent != null && cg.parent.id > 0) {
              // @ts-ignore
              this.treeMap.get(cg.id + "").parent = this.treeMap.get(cg.parent.id + "");
              // @ts-ignore
              var find = this.treeMap.get(cg.parent.id + "").children.find(c => c.key == cg.id + '');
              if (this.deleteKey != "0") {
                // @ts-ignore
                this.treeMap.get(cg.parent.id + "").children = this.treeMap.get(cg.parent.id + "").children.filter(ch => ch.key !== this.deleteKey + "")
                this.deleteKey = "0";
              } else if (!find) {
                // @ts-ignore
                this.treeMap.get(cg.parent.id + "").children.push(this.treeMap.get(cg.id + ""));

              } else {
                find.label = cg.name;
              }
            }
          }
        }
// ........................AddPage.....................
        this.listPage = [];
        for (let cg of this.listCategory) {
          for (let pageDoc of cg.pageDocs) {
            this.listPage.push(pageDoc);
          }
          // cg.pageDocs = cg.pageDocs.sort((a, b) => (a.priority < b.priority ? -1 : 1));
          if (cg.id > 0) {
            if (cg.pageDocs.length > 0) {
              // @ts-ignore
              this.treeMap.get(cg.id + "").children = this.treeMap.get(cg.id + "").children.filter(obj => obj.type !== "PAGE");
              for (let p of cg.pageDocs) {
                var treeGroup: TreeNode = {"data": []};
                treeGroup.key = "p_" + p.id;
                treeGroup.label = p.label;
                treeGroup.children = [];
                treeGroup.type = 'PAGE';
                treeGroup.leaf = true;
                treeGroup.selectable = true;
                treeGroup.styleClass = "tree-page-node";
                if (p.label.length > 48) {
                  treeGroup.styleClass += " tscroll";
                }
                treeGroup.parent = this.treeMap.get(cg.id + "");
                // @ts-ignore
                this.treeMap.get(cg.id + "").children.push(treeGroup);
                if (this.selectedPage == null || this.selectedPage.id < 1) {
                  if (!loadPost) {
                    if (first && (this.global.page == null || this.global.page == "null" || this.global.page == "")) {
                      first = false;
                      this.global.page = p.name;
                      this.selectedPage = p;
                      let path = "dashboard/" + this.selectedDoc.name.replace(" ", "_") + "/" + p.name.replace(" ", "_");
                      window.history.replaceState(null, "", path);
                    } else if (p.name.replace(" ", "_") == this.global.page) {
                      this.selectedPage = p;
                      this.selectedTree = treeGroup;
                      // @ts-ignore
                      this.treeMap.get(cg.id + "").expanded = true;
                      // @ts-ignore
                      if (this.treeMap.get(cg.id + "").parent) {
                        // @ts-ignore
                        this.treeMap.get(cg.id + "").parent.expanded = true;
                        // @ts-ignore
                        if (this.treeMap.get(cg.id + "").parent.parent) {
                          // @ts-ignore
                          this.treeMap.get(cg.id + "").parent.parent.expanded = true;
                          // @ts-ignore
                          if (this.treeMap.get(cg.id + "").parent.parent.parent) {
                            // @ts-ignore
                            this.treeMap.get(cg.id + "").parent.parent.parent.expanded = true;
                          }
                        }
                      }

                    }
                  }
                }
              }
            }
          }
        }
        setTimeout(() => {
          if (this.selectedPage) {
            if (this.selectedTree.parent != null) {
              // @ts-ignore
              this.selectedCategory = this.listCategory.find(c => c.id == this.selectedTree.parent.key);
            }
            this.loadPost(this.selectedPage.id + "");
          }
        }, 100);

        // ..........................................................

        // this.categoryTree = this.categoryTree.sort((c1, c2) => {
        //   if (c1.type != "PAGE") {
        //     return 1;
        //   }
        //   if (c2.type != "PAGE") {
        //     return -1;
        //   }
        //   // @ts-ignore
        //   if (c1.key > c2.key) {
        //     return 1;
        //   }
        //   // @ts-ignore
        //   if (c1.key < c2.key) {
        //     return -1;
        //   }
        //   return 0;
        // });
      } else if (status == 401) {
        this.gotoLogin();
      }

    }, error => {
      this.messageService.clear();
      this.messageService.add({
        severity: 'error',
        summary: $localize`:@@Error:Error`,
        detail: $localize`:@@Server side error:Server side error`
      });
    }).finally(() => {
      this.global.progressBar = false
    });
  }

  openEditPanel() {
    if (this.selectedTree.type == "CATEGORY") {
      this.displayNewCategory = true;
      // @ts-ignore
      this.newCategory = this.listCategory.find(c => c.id == this.selectedTree.key)
    } else if (this.selectedTree.type == "PAGE") {
      this.displayNewPage = true;
      if (this.selectedTree.parent != null) {
        // @ts-ignore
        this.selectedCategory = this.listCategory.find(c => c.id == this.selectedTree.parent.key);
      }
      // @ts-ignore
      this.newPage = this.listPage.find(c => c.id == this.selectedTree.key?.split("_")[1]);
      // this.loadNewPage(this.newPage.id+"");
    }


  }

  // ..............................PageDoc...........................
  selectedPage: PageDoc = new PageDoc();
  newPage: PageDoc = new PageDoc();

  openRootNewPageDialog() {
    this.selectedCategory = new Category();
    this.displayNewPage = true;
    this.newPage = new PageDoc();
  }

  openNewPageDialog() {
    this.displayNewPage = true;
    this.newPage = new PageDoc();
    if (this.selectedTree.type == "CATEGORY") {
      // @ts-ignore
      this.selectedCategory = this.listCategory.find(c => c.id == this.selectedTree.key);
    } else if (this.selectedTree.type == "PAGE") {
      // @ts-ignore
      this.selectedCategory = this.listCategory.find(c => c.id == this.selectedTree.parent.key);
    }
  }

  saveEditPage() {
    if (this.newPage.id < 1) {
      this.savePage("PAGE");
    } else {
      if (this.newPage.publish) {
        // this.savePublishPage();
        this.newPage.lastPublish = new Date().valueOf();
        // this.newPage.html_publish = this.creatHtmlPublishPage();
        this.savePage("PAGE_PUBLISH");
      } else {
        this.savePage("PAGE");
      }
    }
  }

  savePage(mode: string) {
    this.global.progressBar = true;
    let params = {category_id: this.selectedCategory.id, save_mode: mode};
    this.newPage.doc_id = this.selectedDoc.id;
    let body = this.newPage;
    this.global.progressBar = true;
    var observable = this.restBack.doPost("doc/admin/save_page", JSON.stringify(body), params);
    observable.then((res: any) => {
        if (res["status"] == 200) {
          // this.newPage = new PageDoc();
          // if (mode != "POST" && (this.newPage.id ==null || this.newPage.id<1 ))

          let tmp: PageDoc = res["entity"]
          this.selectedPage.lastUpdate = tmp.lastUpdate;
          this.selectedPage.lastPublish = tmp.lastPublish;

          this.getCategoryList(null);
          this.displayNewPage = false;
          this.messageService.clear();
          this.messageService.add({
            severity: 'info',
            summary: $localize`:@@Save:Save`,
            detail: $localize`:@@The page was saved successfully.:The page was saved successfully.`
          });
        }
        if (res["status"] == 400) {
          this.messageService.clear();
          if (res["message"] == "ConflictPageName") {
            this.messageService.add({
              severity: 'error',
              summary: $localize`:@@Error:Error`,
              detail: $localize`:@@The name of the page is repeated in this document.:The name of the page is repeated in this document.`
            });
          } else if (res["message"] == "ConflictPostName") {
            this.messageService.add({
              severity: 'error',
              summary: $localize`:@@Error:Error`,
              detail: $localize`:@@There is a duplicate post name on this page.:There is a duplicate post name on this page.`
            });
          }
        } else if (res["status"] == 401) {
          this.gotoLogin();
        }
      },
      error => {
        this.messageService.clear();
        this.messageService.add({
          severity: 'error',
          summary: $localize`:@@Error:Error`,
          detail: $localize`:@@Server side error:Server side error`
        });
      }).finally(() => {
      this.global.progressBar = false;
    });

  }

  savaContentPage(mode: string) {
    Object.assign(this.newPage, this.selectedPage);
    this.newPage.lastUpdate = new Date().valueOf();
    this.savePage(mode);
  }

  savePublishPage() {
    // for (let post of this.selectedPage.posts) {
    //   for (let postItem of post.postItems) {
    //     postItem.html_code = postItem.html_not_publish;
    //   }
    // }
    this.newPage = this.selectedPage;
    this.newPage.lastPublish = new Date().valueOf();
    // this.newPage.html_publish = this.creatHtmlPublishPage();
    this.savePage("PUBLISH");
  }

  // creatHtmlPublishPage(): string {
  //   var html = "";
  //   let j: number = 0;
  //   for (let post of this.selectedPage.posts) {
  //     html += "<div  class=' grid post-div'>";
  //     html += "<div class=' hashtag col-12 post-title ' id='" + this.creatPostTag(post) + "'><h2>" + post.label + "</h2> " +
  //       "<a href='" + this.creatPostTagLink(post).replace("dashboard/", "") + "'>#</a></div>";
  //     let i: number = 0;
  //     for (let item of post.postItems) {
  //       html += "<div  class='" + (item.itemAttribute.widthClass ? item.itemAttribute.widthClass : "col-12") + " post-item ' id='" + (j + "" + i) + "'> " +
  //         " <div >" + item.html_not_publish + "</div>" +
  //         "</div>"
  //     }
  //     html += "</div>";
  //   }
  //   return html;
  // }

  deletePageDialog() {
    this.confirmationService.confirm({
      message: $localize`:@@Are you sure to delete?:Are you sure to delete?`,
      header: $localize`:@@Delete:Delete`,
      acceptLabel: $localize`:@@Yes:Yes`,
      rejectLabel: $localize`:@@No:No`,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.global.progressBar = true;
        var observable = this.restBack.doGet("doc/admin/delete_page" +
          "?id=" + this.newPage.id
        );
        observable.then((result: any) => {
          var status = result["status"];
          if (status == 200) {
            this.messageService.clear();
            this.messageService.add({
              severity: 'info',
              summary: $localize`:@@Delete:Delete`,
              detail: $localize`:@@The Page was deleted:The Page was deleted`
            });

            // this.deleteKey="p_"+this.newPage.id;
            this.newPage = new PageDoc();
            this.getCategoryList(null);
            this.displayNewPage = false;
          } else if (status == 401) {
            this.gotoLogin();
          }

        }, error => {
          this.messageService.clear();
          this.messageService.add({
            severity: 'error',
            summary: $localize`:@@Error:Error`,
            detail: $localize`:@@Server side error:Server side error`
          });
        }).finally(() => {
          this.global.progressBar = false
        });
      },
      reject: () => {

      }
    });
  }

  nodePageSelect(event: any) {
    if (event.node.type == "PAGE") {
      // @ts-ignore
      this.selectedPage = this.listPage.find(c => "p_" + c.id == event.node.key);
      // this.route.navigate(["dashboard/" + this.selectedDoc.name.replace(" ", "_") + "/" + this.selectedPage.name.replace(" ", "_")]);
      let path = "dashboard/" + this.selectedDoc.name.replace(" ", "_") + "/" + this.selectedPage.name.replace(" ", "_");
      window.history.replaceState(null, "", path);


      setTimeout(() => {
        document.getElementsByClassName("post-main-div")[0].scrollTo(0, 0);
        if (this.selectedPage) {
          if (this.selectedTree.parent != null) {
            // @ts-ignore
            this.selectedCategory = this.listCategory.find(c => c.id == this.selectedTree.parent.key);
          } else {
            this.selectedCategory = new Category();
          }
          this.loadPost(this.selectedPage.id + "");
        }
      }, 100);
    } else {
      event.node.expanded = !event.node.expanded;
    }
  }

  // ......................Post.....................
  newPost: Post = new Post();
  selectedPost: Post = new Post()

  openNewPostDialog() {
    this.itemEditMode = false;
    this.postEditMode = false;
    this.postIndex = -1;
    this.displayNewPost = true;
    this.hashtagList = new Array<string>();
    this.newPost = new Post();
  }

  addPostToPage(editmode: boolean) {
    let accept: boolean = true;
    if (!editmode) {
      for (let post of this.selectedPage.posts) {
        if (this.newPost.name == post.name) {
          this.messageService.clear();
          this.messageService.add({
            severity: 'error',
            summary: $localize`:@@Error:Error`,
            detail: $localize`:@@There is a duplicate post name on this page.:There is a duplicate post name on this page.`
          });
          accept = false;
        }
      }
    }
    if (accept) {
      if (this.postIndex < 0) {
        let priority: number = 0;
        if (this.selectedPage.posts) {
          for (let post of this.selectedPage.posts) {
            if (priority < post.priority) {
              priority = post.priority;
            }
          }
        } else {
          this.selectedPage.posts = new Array<Post>();
        }

        this.newPost.priority = priority++;
        this.selectedPage.posts.push(this.newPost);


      } else {
        this.selectedPage.posts[this.postIndex] = this.newPost;
        this.postIndex = -1;
      }

      this.displayNewPost = false;
      this.postEditMode = false;
      this.savaContentPage("POST");
    }
  }

  removePostFromPage(post: Post) {
    this.confirmationService.confirm({
      message: $localize`:@@Are you sure to delete?:Are you sure to delete?`,
      header: $localize`:@@Delete:Delete`,
      acceptLabel: $localize`:@@Yes:Yes`,
      rejectLabel: $localize`:@@No:No`,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.selectedPage.posts = this.selectedPage.posts.filter(p => p != post);
        this.newPage = this.selectedPage;
        this.savePage("POST")
      },
      reject: () => {
      }
    });
  }

  displayItemType: boolean = false;
  itemDialog: Map<string, boolean> = new Map<string, boolean>();
  tempPostItem: PostItem = new PostItem();
  configHeader: string = "";
  configDialog: boolean = false;
  editorBO: EditorBO = new EditorBO();
  postIndex: number = -1;
  private ngxSunEditor: NgxSuneditorComponent | undefined;

  @ViewChild("suneditor") suneditor: NgxSuneditorComponent | undefined;
  @ViewChild("suneditorNote") suneditorNote: NgxSuneditorComponent | undefined;
  @ViewChild("suneditorTextBox") suneditorTextBox: NgxSuneditorComponent | undefined;
  activeConfig: number = 0;


  loadPost(pageID: string): Promise<string> {
    this.global.hidePostMain = true;
    this.global.progressBar = true;
    var observable = this.restBack.doGet("doc/admin/get_post_list" +
      "?page=0" +
      "&nrpp=500" +
      "&page_id=" + pageID
    );
    observable.then((result: any) => {
      var status = result["status"];
      if (status == 200) {
        this.selectedPage.posts = result["entity"];
        // @ts-ignore
        this.activeRoute.fragment.subscribe((fragment: string) => {
          if (fragment != null) {
            // @ts-ignore
            document.getElementById(fragment).scrollIntoView();
          }
        });
        this.codeTabClick();
      } else if (status == 401) {
        this.gotoLogin();
      }

    }, error => {
      this.messageService.clear();
      this.messageService.add({
        severity: 'error',
        summary: $localize`:@@Error:Error`,
        detail: $localize`:@@Server side error:Server side error`
      });
    }).finally(() => {
      this.global.progressBar = false
      this.global.hidePostMain = false;
    });
    return observable;
  }

  showNewItemDialog(post: Post) {
    this.itemEditMode = false;
    this.selectedPost = post;
    this.displayItemType = true;

  }

  showEitePostDialog(post: Post, index: number) {
    this.postEditMode = true;
    this.newPost = post;
    this.postIndex = index;
    this.hashtagList = [];
    if (this.newPost.hashtag)
      this.hashtagList = this.newPost.hashtag.split(",");
    else
      this.hashtagList = new Array<string>();
    this.displayNewPost = true;
  }

  selectTypeItemDialog(type: string) {
    this.tempPostItem = new PostItem();
    this.tempPostItem.type = type;
    for (let item of this.selectedPost.postItems) {
      if (item.priority > this.tempPostItem.priority) {
        this.tempPostItem.priority = item.priority;
      }
    }


    if (type == "TITLE") {
      this.configHeader = $localize`:@@Title:Title`;
      this.itemDialog.set("TITLE", true);
      this.tempPostItem.style.font_size = "20px";
      this.tempPostItem.style.font_weight = "bold";
      this.tempPostItem.itemAttribute.value = "";

    } else if (type == "TEXT") {
      setTimeout(() => {
        this.editorBO = new EditorBO();
        this.suneditor?.setOptions(this.editorBO.editorOptions);
        this.suneditor ? this.suneditor.content = "" : "";

      }, 10);

      this.configHeader = $localize`:@@Text:Text`;
      this.itemDialog.set("TEXT", true);
      this.tempPostItem.itemAttribute.value = "";

    } else if (type == "TEXTBOX") {
      setTimeout(() => {
        this.editorBO = new EditorBO();
        this.suneditorTextBox?.setOptions(this.editorBO.editorOptionsLite);
        this.suneditorTextBox ? this.suneditorTextBox.content = "" : "";
      }, 10);

      this.configHeader = $localize`:@@Text:Text`;
      this.itemDialog.set("TEXT", true);
      this.tempPostItem.itemAttribute.value = "";
      this.tempPostItem.itemAttribute.type = "text";

    } else if (type == "CODE") {
      this.configHeader = $localize`:@@Code:Code`;
      this.itemDialog.set("CODE", true);
      this.tempPostItem.itemAttribute.value = "";
      this.codeItemValue = [{title: $localize`:@@New Tab:New Tab`, value: ''}]
      this.tempPostItem.itemAttribute.class_style = "searchia-docs-code1";

    } else if (type == "NOTE") {

      setTimeout(() => {
        this.editorBO = new EditorBO();
        this.suneditorNote?.setOptions(this.editorBO.editorOptions);
        this.suneditorNote ? this.suneditorNote.content = "" : "";
      }, 10);
      this.configHeader = $localize`:@@Note:Note`;
      this.itemDialog.set("NOTE", true);
      this.tempPostItem.itemAttribute.value = "";
      this.tempPostItem.itemAttribute.class_style = "searchia-docs-notice1";

    } else if (type == "WARN") {
      this.configHeader = $localize`:@@Warning:Warning`;
      this.itemDialog.set("WARN", true);
      this.tempPostItem.itemAttribute.value = "";
      this.tempPostItem.itemAttribute.class_style = "searchia-docs-warning1";

    } else if (type == "TAG") {
      this.configHeader = $localize`:@@Tag:Tag`;
      this.itemDialog.set("TAG", true);
      this.tempPostItem.itemAttribute.value = "";
      this.tempPostItem.itemAttribute.class_style = "searchia-docs-tag";

    } else if (type == "DIVIDER") {
      this.configHeader = $localize`:@@Divider:Divider`;
      this.itemDialog.set("DIVIDER", true);
      this.tempPostItem.itemAttribute.value = "";
      this.tempPostItem.itemAttribute.class_style = "searchia-docs-title-divider";

    } else if (type == "IMAGE") {
      this.configHeader = $localize`:@@Image:Image`;
      this.itemDialog.set("IMAGE", true);
      this.tempPostItem.itemAttribute.src = "";
    } else if (type == "LIST") {
      this.configHeader = $localize`:@@List:List`;
      this.itemDialog.set("LIST", true);
      this.tempPostItem.itemAttribute.value = "";
    } else if (type == "SPACE") {
      this.configHeader = $localize`:@@Space:Space`;
      this.itemDialog.set("SPACE", true);
      this.tempPostItem.itemAttribute.value = "";
    }
    this.activeConfig = 1;
    this.displayItemType = false;
    this.configDialog = true;
    setTimeout(() => {
      this.activeConfig = 0;
    }, 10)


  }

// ......................................add Items..................................
  showItemInPost(post: Post, item: PostItem): string {
    // this.selectedPost = post;
    // this.tempPostItem = item;
    return this.creatItemHtml(item, 0, true);
  }

  creatItemHtml(item: PostItem, time: number, editMode: boolean): string {
    let innerHtml = "";
    var countItem = this.selectedPost.postItems.length;
    var style = ItemStyle.getStyle(item.style);
    //..............................TITLE............................
    if (item.type == "TITLE") {
      innerHtml = "<h2 class='" + item.itemAttribute.class_style + "'  style=\"" + style + "\" >" + item.itemAttribute.value + "</h2>";
    }
    //........................Text..................................
    else if (item.type == "TEXT") {
      // innerHtml="<h2 style=\""+style+"\" >"+item.attr.value+"</h2>";
      if (!editMode) {
        const textarea: HTMLInputElement = this.suneditor ? this.suneditor.save(false) as HTMLInputElement : new HTMLInputElement();
        item.itemAttribute.value = textarea.value;
      }
      innerHtml = "<div class='sun-editor-editable' style=\"" + style + "\"  >" + item.itemAttribute.value + "</div>";
    }

    //........................TextBox..................................
    else if (item.type == "TEXTBOX") {
      if (!editMode) {
        // innerHtml="<h2 style=\""+style+"\" >"+item.attr.value+"</h2>";
        const textarea: HTMLInputElement = this.suneditorTextBox ? this.suneditorTextBox.save(false) as HTMLInputElement : new HTMLInputElement();
        item.itemAttribute.value = textarea.value;
      }
      innerHtml = "<div class='sun-editor-editable searchia-docs-textbox " + item.itemAttribute.class_style + "' style=\"" + style + "\"  >";
      if (item.itemAttribute.label.length > 0)
        innerHtml += "<div class='box-title'>" + item.itemAttribute.label + "</div>";
      if (item.itemAttribute.type != "json")
        innerHtml += "<div class='box-value'>" + item.itemAttribute.value + "</div></div>";
      else {
        let t = {};
        try {
          t = JSON.parse(item.itemAttribute.value2)
        } catch (e) {
        }
        innerHtml += "<div class='box-value' style='white-space: pre-wrap;font-family: monospace;'>" + JSON.stringify(t, null, 4) + "</div></div>";
      }
    }

    //........................Note..................................
    else if (item.type == "NOTE") {
      if (!editMode) {
        const textarea: HTMLInputElement = this.suneditorNote ? this.suneditorNote.save(false) as HTMLInputElement : new HTMLInputElement();
        item.itemAttribute.value = textarea.value;
      }
      innerHtml = "<div style=\"" + style + "\" class='" + item.itemAttribute.class_style + "'>" +
        "<div class='title' >" + item.itemAttribute.type + ":</div><div class='body'>";
      // for (let s of item.itemAttribute.value.split("\n")) {
      //   innerHtml += s + "<br/>";
      // }
      innerHtml += item.itemAttribute.value;
      innerHtml += "</div></div>";
    }

    //........................Tag..................................
    else if (item.type == "TAG") {
      // innerHtml = "";
      for (let s of item.itemAttribute.value.split(",")) {
        innerHtml += "<div style=\"" + style + "\" class='" + item.itemAttribute.class_style + "'>" +
          s +
          "</div>";
      }
    }

    //........................DIVIDER..................................
    else if (item.type == "DIVIDER") {
      innerHtml = "<div style=\"" + style + "\" class='" + item.itemAttribute.class_style + "'>" +
        "</div>";
    }

    //........................Code..................................
    else if (item.type == "CODE") {
      let codeItem: any[] = [];
      if (!editMode) {
        item.itemAttribute.value = JSON.stringify(this.codeItemValue);
        codeItem = this.codeItemValue;
      } else {
        codeItem = JSON.parse(item.itemAttribute.value);
      }
      innerHtml = "<div style=\"" + style + ";\" class='" + item.itemAttribute.class_style + "'>" +
        "<div class='codeType'>" + item.itemAttribute.type + "</div> ";
      innerHtml += "<div style='width: 100%;text-align: right;margin-bottom: 10px'>" + item.itemAttribute.description + "</div>";
      let j = 1;
      innerHtml += "<div class='codeTabView ctv-" + (countItem + 1) + "'>";
      if (codeItem[0] != null && codeItem[0]["title"].length > 0) {
        innerHtml += "<div class='tabs-row'  >";
        for (let itm of codeItem) {
          if (itm["title"].length > 0) {
            innerHtml += "<div class='code-tabs item-tab-" + (countItem + 1) + " cttab-" + (countItem + 1) + "-" + j + "'" +
              " data-value='ctb-" + (countItem + 1) + "-" + j + "' data-mode='" + (countItem + 1) + "' style='cursor: pointer' " +
              ">" + itm["title"] + "</div>";
            j++;
          }
        }
        innerHtml += "</div>";
      }
      let y = 1;
      for (let itm of codeItem) {
        innerHtml += "<div style='display: " + (y == 1 ? "" : "none") + "' class='code-tab-body item-body-" + (countItem + 1) + " ctb-" + (countItem + 1) + "-" + y + "'>";
        innerHtml += "<div id='code-copy-" + (countItem + 1) + "-" + y + "' style='display: none'>" + itm['value'] + "</div>";
        innerHtml += "<div  class=' item-body-copy ' data-mode='code-copy-" + (countItem + 1) + "-" + y + "' >" +
          "</div>";
        let i = 1;
        for (let s of itm["value"].split("\n")) {
          innerHtml += "<div style='display: flex'><div class='number'>" + (i++) + "</div><div class='code'>" + s + "</div></div>";
        }
        innerHtml += "</div>";
        y++;
      }
      innerHtml += "</div></div>";

    } else if (item.type == "LIST") {
      innerHtml = "<div style=\"" + style + ";\" class='searchia-docs-ul ' ><ul class='" + item.itemAttribute.class_style + "'> ";
      let i = 1;
      for (let s of item.itemAttribute.value.split("\n")) {
        innerHtml += "<li>" + s + "</li>";
      }
      innerHtml += "</ul></div>";
    } else if (item.type == "IMAGE") {
      item.itemAttribute.type = "IMAGE";
      item.itemAttribute.value = "IMAGE";

      innerHtml = "<div style=\"" + style + ";\" class='doc-img-div'>  ";

      innerHtml += "<figure><img style='width:" + item.itemAttribute.width + ";'  class='" + item.itemAttribute.class_style + "' " +
        "src='" + item.itemAttribute.src + "'></img>" +
        "<figcaption>" + item.itemAttribute.label + "</figcaption></figure>";

      innerHtml += "</div>";

      time = 2000;

    } else if (item.type == "API") {
      innerHtml = "<div style=\"" + style + ";\" class='searchia-docs-api " + item.itemAttribute.class_style + "'>" +
        "<div style='display: flex;padding: 4px;'>" +
        "<div style='display: table'><div  class='api-type'>" + item.itemAttribute.type + "</div></div>" +
        "<div  class='api-value'>" + item.itemAttribute.value + "</div>" +
        "</div>  ";
      innerHtml += "</div>";
    } else if (item.type == "SPACE") {
      innerHtml = "<div> ";
      innerHtml += "</div>";
    }

    // item.html_not_publish = innerHtml;
    // if (item.html_not_publish === innerHtml) {
    //   console.log("_______ok_______________"+item.priority);
    // }else {
    //   console.log("_______changed_______________"+item.priority);
    // }
    return innerHtml;
  }

  addItemToPage() {
    let innerHtml: string = "";
    let time: number = 0;
    innerHtml = this.creatItemHtml(this.tempPostItem, time, false);

    setTimeout(() => {
      // this.tempPostItem.html_not_publish = innerHtml;
      if (!this.itemEditMode)
        this.selectedPost.postItems.push(this.tempPostItem);
      this.configDialog = false;
      this.itemEditMode = false;
      this.savaContentPage("POST");
      this.codeTabClick();
    }, time);


  }


  openEditPostItem(item: PostItem) {
    this.tempPostItem = item;
    this.itemEditMode = true;
    if (item.type == "TEXT") {
      setTimeout(() => {
        this.editorBO = new EditorBO();
        this.suneditor?.setOptions(this.editorBO.editorOptions);
        this.suneditor ? this.suneditor.content = item.itemAttribute.value : "";
      }, 200);
      // @ts-ignore
      // this.suneditor?.setContents();

    }
    if (item.type == "CODE") {
      this.codeItemValue = JSON.parse(item.itemAttribute.value);
    }
    if (item.type == "TEXTBOX") {
      setTimeout(() => {
        this.editorBO = new EditorBO();
        this.suneditorTextBox?.setOptions(this.editorBO.editorOptionsLite);
        this.suneditorTextBox ? this.suneditorTextBox.content = item.itemAttribute.value : "";
      }, 200);

    }
    if (item.type == "NOTE") {
      setTimeout(() => {
        this.editorBO = new EditorBO();
        this.suneditorNote?.setOptions(this.editorBO.editorOptionsLite);
        this.suneditorNote ? this.suneditorNote.content = item.itemAttribute.value : "";
      }, 200);
    }
    this.activeConfig = 1;
    setTimeout(() => {
      this.activeConfig = 0;
    }, 10)
    this.configDialog = true;
    // console.log(this.tempPostItem);

  }

  removeItem(post: Post, item: PostItem) {
    this.confirmationService.confirm({
      message: $localize`:@@Are you sure to delete?:Are you sure to delete?`,
      header: $localize`:@@Delete:Delete`,
      acceptLabel: $localize`:@@Yes:Yes`,
      rejectLabel: $localize`:@@No:No`,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        post.postItems = post.postItems.filter(i => i != item);
        this.savaContentPage("POST");
        // this.selectedPost.postItems = this.selectedPost.postItems.filter(i => i.id != item.id);
      },
      reject: () => {

      }
    });

  }


  dragDiv(ev: any) {
    ev.dataTransfer.setData("text", ev.target.id);
  }

  dropDiv(ev: any) {

    ev.preventDefault();
    var data = ev.dataTransfer.getData("text");

    let thisdiv: Element = ev.target;

    if (thisdiv.className.indexOf("post-item") > -1) {
      // @ts-ignore
      document.getElementById(data).ertBefore(thisdiv, null);
    }

  }

  onDragOver(event: Event) {
    event.preventDefault();
  }


  upPost(page: PageDoc, i: number) {
    let temp: PageDoc = new PageDoc();
    Object.assign(temp, page.posts[i - 1])
    Object.assign(page.posts[i - 1], page.posts[i]);
    Object.assign(page.posts[i], temp);
    for (let j = 0; j < page.posts.length; j++) {
      page.posts[j].priority = j;
    }
    this.savaContentPage("POST");
    // this.sortItems(post);


  }

  downPost(page: PageDoc, i: number) {
    let temp: PageDoc = new PageDoc();
    Object.assign(temp, page.posts[i + 1])
    Object.assign(page.posts[i + 1], page.posts[i]);
    Object.assign(page.posts[i], temp);
    for (let j = 0; j < page.posts.length; j++) {
      page.posts[j].priority = j;
    }
    this.savaContentPage("POST");

  }

  upItem(post: Post, i: number) {
    let temp: PostItem = new PostItem();
    Object.assign(temp, post.postItems[i - 1])
    Object.assign(post.postItems[i - 1], post.postItems[i]);
    Object.assign(post.postItems[i], temp);
    for (let j = 0; j < post.postItems.length; j++) {
      post.postItems[j].priority = j;
    }
    this.savaContentPage("POST");
    // this.sortItems(post);


  }

  downItem(post: Post, i: number) {
    let temp: PostItem = new PostItem();
    Object.assign(temp, post.postItems[i + 1])
    Object.assign(post.postItems[i + 1], post.postItems[i]);
    Object.assign(post.postItems[i], temp);
    for (let j = 0; j < post.postItems.length; j++) {
      post.postItems[j].priority = j;
    }
    this.savaContentPage("POST");

  }

  sortItems(post: Post) {
    post.postItems = post.postItems.sort((a, b) => (a.priority > b.priority ? -1 : 1));

  }

  creatPostTag(post: Post): string {
    return post.name.replace(" ", "_");
  }

  creatPostTagLink(post: Post): string {
    return window.location.pathname + "#" + post.name.replace(" ", "_");
  }


  loadNewPage(pageID: string): Promise<string> {
    this.global.progressBar = true;
    var observable = this.restBack.doGet("doc/page/get_pages" +
      "?id=" + pageID
    );
    observable.then((result: any) => {
      var status = result["status"];
      if (status == 200) {
        let a: Array<PageDoc> = result["entity"];
        if (a.length > 0) {
          this.newPage = a[0];
        }
        // this.loadPost(pageID);
        this.codeTabClick();
      } else if (status == 401) {

      }

    }, error => {
      this.messageService.clear();
      this.messageService.add({
        severity: 'error',
        summary: $localize`:@@Error:Error`,
        detail: $localize`:@@Server side error:Server side error`
      });
    }).finally(() => {
      this.global.progressBar = false

    });
    return observable;
  }


  private sortPage(inc: number) {
    let category: Category = new Category();
    let pg: PageDoc = new PageDoc();

    if (this.selectedTree.type == "PAGE") {
      if (this.selectedTree.parent) {
        // @ts-ignore
        category = this.listCategory.find(c => c.id == this.selectedTree.parent.key);
      } else {
        category.id = 0;
      }
      // @ts-ignore
      pg = this.listPage.find(c => c.id == this.selectedTree.key?.split("_")[1]);
    } else {
      // @ts-ignore
      category = this.listCategory.find(c => c.id == this.selectedTree.key);
    }
    this.global.progressBar = true;
    var observable = this.restBack.doGet("doc/admin/save_sort_page" +
      "?cat_id=" + category.id +
      (this.selectedTree.type == "PAGE" ? "&page_id=" + pg.id : "") +
      "&doc_id=" + this.selectedDoc.id +
      "&inc=" + (inc == 1 ? true : false)
    );
    observable.then((result: any) => {
      var status = result["status"];
      if (status == 200) {
        this.getCategoryList(null);
      } else if (status == 401) {
        this.gotoLogin();
      }

    }, error => {
      this.messageService.clear();
      this.messageService.add({
        severity: 'error',
        summary: $localize`:@@Error:Error`,
        detail: $localize`:@@Server side error:Server side error`
      });
    }).finally(() => {
      this.global.progressBar = false
    });
    return undefined;
  }

  showContextMenu() {
    for (let contextItem of this.contextItems) {
      if (this.selectedTree.type == "CATEGORY" && (contextItem.id == "3" || contextItem.id == "4")) {
        contextItem.visible = false;
      }
      if (this.selectedTree.type == "PAGE" && (contextItem.id == "2")) {
        contextItem.visible = false;
      } else {
        contextItem.visible = true;
      }
    }
  }

  setNewPostHashtag() {
    this.newPost.hashtag = this.hashtagList.toString();
  }

  creatNavCategoryList(): Array<Category> {
    let list: Array<Category> = new Array<Category>();
    if (this.selectedCategory != null && this.selectedCategory.id > 0) {
      list.push(this.selectedCategory);
      let parent: Category | undefined = this.selectedCategory.parent;
      while (true) {
        if (parent != null) {
          list.push(parent ? parent : new Category());
          if (parent?.parent != null) {
            parent = parent.parent;
          } else {
            break;
          }
        } else {
          break;
        }
      }
    }
    list.reverse();
    return list;

  }

  codeItemNewTab() {
    this.codeItemValue.push({title: $localize`:@@New Tab:New Tab`, value: ''});
  }

  codeTabClick() {
    setTimeout(() => {
      try {
        var elements2: HTMLCollectionOf<Element> = document.getElementsByClassName("code-tabs");
        elements2[0].className = elements2[0].className + " active";
        for (var k = 0; k < elements2.length; k++) {
          elements2[k].addEventListener("click", (e) => {
            try {
              // @ts-ignore
              let itemIndex: string = e.target['attributes']['data-mode'].value;


              var el1: HTMLCollectionOf<Element> = document.getElementsByClassName("item-tab-" + itemIndex);
              for (var z = 0; z < el1.length; z++) {
                el1[z].className = el1[z].className.replace(" active", "");
              }
              (e.target as HTMLDivElement).className = (e.target as HTMLDivElement).className + " active";

              // @ts-ignore
              let temp: string = e.target['attributes']['data-value'].value;


              var elements: HTMLCollectionOf<Element> = document.getElementsByClassName("item-body-" + itemIndex);
              for (var j = 0; j < elements.length; j++) {
                elements[j].setAttribute("style", "display: none;");
              }
              var elements2: HTMLCollectionOf<Element> = document.getElementsByClassName(temp);
              for (var j = 0; j < elements2.length; j++) {
                elements2[j].setAttribute("style", "");
              }
            } catch (e) {
            }
          });
        }
      } catch (e) {
      }

      var elements3: HTMLCollectionOf<Element> = document.getElementsByClassName("item-body-copy");
      for (var k = 0; k < elements3.length; k++) {
        elements3[k].innerHTML = $localize`:@@Copy:Copy`;
        elements3[k].addEventListener("click", (e) => {
          // @ts-ignore
          let val: string = e.target['attributes']['data-mode'].value;

          // @ts-ignore
          this.copyToClipboard(document.getElementById(val).innerText);
          // @ts-ignore
          e.target['innerHTML'] = $localize`:@@Copied:Copied`;
          setTimeout(() => {
            // @ts-ignore
            e.target['innerHTML'] = $localize`:@@Copy:Copy`;
          }, 1000 * 30)

        });
      }
    }, 200);


  }


  imgFile: any;
  imgTemp: String = "";


  addImage(event: any) {
    let input = event.target;
    for (var index = 0; index < input.files.length; index++) {
      this.imgFile = input.files[index];

      // let reader = new FileReader();
      // reader.onload = () => {
      //   // this 'text' is the content of the file
      //   // reader.result;
      //   // @ts-ignore
      //   this.tempPostItem.itemAttribute.value = reader.result;
      //
      // }
      // reader.readAsDataURL(input.files[index]);
    }

  }


  uploadFile(event: any, inputFile: FileUpload) {
    for (let file of event.files) {
      this.imgFile = file;
      let reader = new FileReader();
      reader.onload = () => {
        // this 'text' is the content of the file
        var text = reader.result;
        // this.uploadList.set(key,text);
        this.imgTemp = text + "";
        return false;
      }
      // Read in the image file as a data URL.
      reader.readAsDataURL(file);
    }
    inputFile.clear();
  }

  uploadImg() {
    this.global.progressBar = true;
    var observable = this.restBack.doUploadPost("/doc/file/upload",
      this.imgFile,
      {
        "type": "ImgItem"
      });
    return observable.then(res => {
      if (res["status"] == 200) {
        let upload: UploadFile = res['entity'];
        this.tempPostItem.itemAttribute.value = upload.id + "";
      }
    }, error => {
      this.messageService.add({
        severity: 'error',
        summary: $localize`:@@Error:Error`,
        detail: $localize`:@@Server side error:Server side error`
      });
    }).finally(() => {
      this.global.progressBar = false
    });


  }

  imgNamefilter: string = "";
  imgIdFilter: string = "";
  listUploadFile: Array<UploadFile> = new Array<UploadFile>();
  totalImage: number = 20;

  getImgList(table: any) {
    this.global.progressBar = true;
    var observable = this.restBack.doGet("/doc/file/get_list?" +
      "page=" + (table != null ? table.first / 12 : 0) +
      "&nrpp=" + (table != null ? table.rows : 12) +
      "&id=" + this.imgIdFilter +
      "&name=" + this.imgNamefilter
    );
    observable.then((result: any) => {
      var status = result["status"];
      if (status == 200) {
        this.listUploadFile = result["entity"];
        this.totalImage = result["total"];
      } else if (status == 401) {
        this.gotoLogin();
      }

    }, error => {
      this.messageService.clear();
      this.messageService.add({
        severity: 'error',
        summary: $localize`:@@Error:Error`,
        detail: $localize`:@@Server side error:Server side error`
      });
    }).finally(() => {
      this.global.progressBar = false
    });
  }

  displayImageCenter: boolean = false;
  imgSelectable: Boolean = false;
  imgSelected: UploadFile = new UploadFile();

  openImageCenter(tbl: any) {
    this.displayImageCenter = true;
    this.getImgList(tbl);

  }

  selectImage(img: UploadFile) {
    // this.imgSelected = img;
    this.imgSelectable = false;
    this.displayImageCenter = false;
    if (this.tempPostItem.type == 'IMAGE') {
      this.tempPostItem.itemAttribute.src = "/doc/file/get_pic?uid=" + img.uid + "";
    }
  }

  getCenterHeight(): number {
    var elements = document.getElementsByClassName("doc-main-div");
    // // @ts-ignore
    // @ts-ignore
    return elements[0].offsetHeight;

  }

  copyToClipboard(text: string) {
    // var input = document.body.appendChild(document.createElement("input"));
    // input.value = text;
    // input.focus();
    // input.select();
    // document.execCommand('copy');
    console.log(text);
    navigator.clipboard.writeText(text);
    // @ts-ignore
    // input.parentNode.removeChild(input);
    this.messageService.clear();
    this.messageService.add({
      severity: 'info',
      summary: $localize`:@@Copy:Copy`,
      detail: $localize`:@@The address was copied.:The address was copied.`
    });
  }

  deleteIMG(id: number, tbl: any) {
    this.confirmationService.confirm({
      message: $localize`:@@Are you sure to delete?:Are you sure to delete?`,
      header: $localize`:@@Delete:Delete`,
      acceptLabel: $localize`:@@Yes:Yes`,
      rejectLabel: $localize`:@@No:No`,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.global.progressBar = true;
        var observable = this.restBack.doGet("doc/file/delete" +
          "?id=" + id
        );
        observable.then((result: any) => {
          var status = result["status"];
          if (status == 200) {
            this.getImgList(tbl);
            this.messageService.clear();
            this.messageService.add({
              severity: 'info',
              summary: $localize`:@@Delete:Delete`,
              detail: $localize`:@@The image was deleted:The image was deleted`
            });
          }

        }, error => {
          this.messageService.clear();
          this.messageService.add({
            severity: 'error',
            summary: $localize`:@@Error:Error`,
            detail: $localize`:@@Server side error:Server side error`
          });
        }).finally(() => {
          this.global.progressBar = false
        });
      },
      reject: () => {

      }
    });
  }


}
